import { jsx as _jsx } from "react/jsx-runtime";
import { SkapaSkeleton, SkapaStatus } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
import { StyledAvailability } from './styles';
export const ProductAvailability = ({ storeName, isLoading, available, availableMessage, unavailableMessage }) => {
    const { isCompact } = useGuidaUIStates();
    const availabilityMessage = (available) => {
        if (available) {
            return isCompact ? availableMessage : availableMessage + ' ' + storeName;
        }
        return isCompact ? unavailableMessage : unavailableMessage + ' ' + storeName;
    };
    if (isLoading) {
        return _jsx(SkapaSkeleton, { height: '14px', width: '60%' });
    }
    if (!storeName) {
        return null;
    }
    if (available === true) {
        return (_jsx(StyledAvailability, { "data-testid": 'product-availability', children: _jsx(SkapaStatus, { statusColor: 'green', small: true, label: availabilityMessage(true), statusDotPosition: 'inline' }) }));
    }
    if (available === false) {
        return (_jsx(StyledAvailability, { "data-testid": 'product-availability', children: _jsx(SkapaStatus, { statusColor: 'red', small: true, label: availabilityMessage(false), statusDotPosition: 'inline' }) }));
    }
    return _jsx(StyledAvailability, {});
};
//# sourceMappingURL=ProductAvailability.js.map